import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import {
  fetchSystemsFailure,
  fetchSystemsStart,
  fetchSystemsSuccess,
  fetchSystemsSummaryFailure,
  fetchSystemsSummaryStart,
  fetchSystemsSummarySuccess
} from '../../store/slices/aiSystemsSlice';
import {
  fetchAISystems,
  getAiSystemsSummary
} from '../../services/AISystemsService';

export function useAiSystemOverview() {
  const dispatch = useAppDispatch();
  const { filters, pagination } = useAppSelector((state) => state.aiSystems);

  const fetchSystemsSummary = async () => {
    dispatch(fetchSystemsSummaryStart());
    try {
      const response = await getAiSystemsSummary();
      dispatch(fetchSystemsSummarySuccess(response));
    } catch (error) {
      if (error instanceof Error) {
        dispatch(fetchSystemsSummaryFailure(error.message));
      }
    }
  };

  const fetchSystems = async (
    useFilters = true,
    ownerId?: string,
    suppressForbiddenRedirect = false
  ) => {
    dispatch(fetchSystemsStart());
    try {
      const response = useFilters
        ? await fetchAISystems({
            search: filters.search,
            entity: filters.entity,
            riskClassification: filters.riskClassification,
            complianceStatus: filters.complianceStatus,
            ownerId: filters.owners,
            organization: filters.organization,
            offset: pagination.offset,
            limit: pagination.limit
          })
        : await fetchAISystems(ownerId ? { ownerId: [ownerId] } : undefined, {
            suppressForbiddenRedirect
          });

      dispatch(fetchSystemsSuccess(response));
    } catch (error: any) {
      dispatch(fetchSystemsFailure(error.message));
    }
  };

  return {
    fetchSystemsSummary,
    fetchSystems
  };
}
